import React from 'react';

class Config {

    constructor() {
        this.images = [];
    }

    getBaseUrl() {

        if (window.location.hostname.indexOf('localhost') >-1) {
            //Change to localhost image repo
            return "https://beta.assets.languagenut.com/";
        } else if (window.location.hostname.indexOf('beta') >-1) {
            return "https://beta.assets.languagenut.com/";
        } else if (window.location.hostname.indexOf('alpha') >-1) {
            return "https://beta.assets.languagenut.com/";
        } else if (window.location.hostname.indexOf('gamma') >-1) {
            return "https://storage.languagenut.com/";
        } else {
            return "https://storage.languagenut.com/";
        }
    }

    getFeedbackBaseUrl() {

        if (window.location.hostname.indexOf('localhost') >-1) {
            //Change to localhost image repo
            return "https://beta.assets.languagenut.com/";
        } else if (window.location.hostname.indexOf('beta') >-1) {
            return "https://beta.assets.languagenut.com/";
        } else if (window.location.hostname.indexOf('alpha') >-1) {
            return "https://beta.assets.languagenut.com/";
        } else if (window.location.hostname.indexOf('gamma') >-1) {
            return "https://beta.assets.languagenut.com/";
        } else {
            return "https://storage.languagenut.com/";
        }
    }

    getAudioBaseUrl() {

        if (window.location.hostname.indexOf('localhost') >-1) {
            //Change to localhost image repo
            return "https://beta.assets.languagenut.com/";
        } else if (window.location.hostname.indexOf('beta') >-1) {
            return "https://beta.assets.languagenut.com/";
        } else if (window.location.hostname.indexOf('alpha') >-1) {
            return "https://beta.assets.languagenut.com/";
        } else if (window.location.hostname.indexOf('gamma') >-1) {
            return "https://storage.languagenut.com/";
        } else {
            return "https://storage.languagenut.com/";
        }
    }

    getImagePath(){
        return this.getAudioBaseUrl().replace(/\/$/, "") + (window.location.hostname.indexOf('localhost') >-1 ? "/" : "/");
    }

    isLive() {
        return window.location.hostname.indexOf('localhost') == -1 && window.location.hostname.indexOf('beta') == -1;
    }
}

export default new Config();

